import React from "react";
import { Modal } from "react-bootstrap";
import Back from "assets/images/svg/back_blue.svg";
import { AddonModule } from "pages/details/app-detail.service";
import { useQuery } from "react-query";
import { client } from "helpers/client";
import ServerImage from "components/server-image/server-image";
import { Link } from "react-router-dom";
import {json} from "helpers/data";

interface Props {
  onHide: () => void;
  module: AddonModule | null;
}

const ModuleDialog = ({ onHide, module }: Props) => {
  const { data = {} } = useQuery<any>(
    ["module", module?.id],
    () => client(`apps/module/${module?.id}`).then((r) => r.response ?? {}),
    { enabled: !!module }
  );

  return (
    <div>
      <Modal
        size="lg"
        centered
        show={!!module}
        onHide={onHide}
        className="all-modal appDetails"
      >
        <Modal.Body>
          <div className="header">
            <img src={Back} alt="back" onClick={onHide} />
            <h1>{json(module?.title ?? '')}</h1>
          </div>
          <ServerImage className="img-logo" src={data.sliderPath} />
          <div className="description" dangerouslySetInnerHTML={{__html: json(data.description ?? '')}} />
          <Link className="full" to={`/module/${module?.id}`}>view module</Link>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ModuleDialog;
